import gql from 'graphql-tag';

export const INVESTMENT_OBJECTIVE_KEY_FACTS_BOTTOM = gql`
    query InvestmentObjectiveFactsBottom($ticker: String!) {
        mutualFund(ticker: $ticker) {
            ticker
            fiscalYearEndMonth
            fiscalYearEnd
            inceptionDate
            cusip
            taxID
        }
    }
`;

export const ETF_INVESTMENT_OBJECTIVE_KEY_FACTS_BOTTOM = gql`
    query ETFInvestmentObjectiveFactsBottom($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            inavTicker
            ticker
            fiscalYearEnd
            inceptionDate
            cusip
            transparencyTypeName
        }
    }
`;

export const INVESTMENT_OBJECTIVE_KEY_FACTS_TOP = gql`
    query InvestmentObjectiveFactsTop($ticker: String!) {
        mutualFund(ticker: $ticker) {
            objective
            strategyText
            riskRewardText
        }
    }
`;

export const ETF_INVESTMENT_OBJECTIVE_KEY_FACTS_TOP = gql`
    query ETFInvestmentObjectiveFactsTop($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            objective
            strategyText
            riskRewardText
        }
    }
`;

export const FUND_MANAGER = gql`
    query InvestmentObjectiveFundManager($ticker: String!) {
        mutualFund(ticker: $ticker) {
            mutualFundManagers {
                managerID
                managerName
                title
                managedFundSinceDate
                joinedFirmDate
                headShots2 {
                    path
                    width
                    height
                }
            }
        }
    }
`;

export const ETF_FUND_MANAGER = gql`
    query ETFInvestmentObjectiveFundManager($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            mutualFundManagers {
                managerID
                managerName
                title
                managedFundSinceDate
                joinedFirmDate
                headShots2 {
                    path
                    width
                    height
                }
            }
        }
    }
`;
